export const officeAddresses = [
  // {
  //   label: "Head Office",
  //   address:
  //     "Second Floor, Plot No. 13, Delhi University Teachers Cooperative House Building Society Ltd, Power House Road, New Delhi, North West Delhi - 110034",
  // },
  {
    label: "Branch Address",
    address:
      "2nd Floor, Property Bearing No.- 13, Beside Aakash Institute, Vaishali Enclave, Pitampura, Delhi-110034",
  },
];

export const supportPhone = "+91 9315033113"; //"+91 84680 09254 / 9315033113";
export const supportEmail = "support@truxcargo.com";
export const officeMapQuery =
  "Second Floor, Plot No. 13, Delhi University Teachers Cooperative House Building Society Ltd, Power House Road, New Delhi, North West Delhi - 110034";
